import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-right",
  "use": "icon-chevron-right-usage",
  "viewBox": "0 0 8 14",
  "content": "<symbol viewBox=\"0 0 8 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-chevron-right\">\n<path d=\"M1 13.7487C0.810002 13.7487 0.620002 13.6787 0.470002 13.5287C0.180002 13.2387 0.180002 12.7587 0.470002 12.4687L5.94 6.99872L0.470002 1.52872C0.180002 1.23872 0.180002 0.758721 0.470002 0.468721C0.760002 0.178721 1.24 0.178721 1.53 0.468721L7.53 6.46872C7.82 6.75872 7.82 7.23872 7.53 7.52872L1.53 13.5287C1.38 13.6787 1.19 13.7487 1 13.7487Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol